import { useShallow } from 'zustand/shallow';

import { HcoSection } from '@/pages/MyDCRsPage/ViewDCRModal/_hooks/useHcoFieldNames';
import { HcpSection } from '@/pages/MyDCRsPage/ViewDCRModal/_hooks/useHcpFieldNames';

import { useDcrStore } from './dcrStore';

export const useDcrFormSearchTerm = () =>
	useDcrStore(({ dcrFormSearchTerm }) => dcrFormSearchTerm);

export const useDcrFormFilteredFields = (section: HcoSection | HcpSection) =>
	useDcrStore(
		useShallow(
			({ dcrFormFilteredFields }) => dcrFormFilteredFields[section] ?? []
		)
	);

export const useSetDcrFormSearchTerm = () =>
	useDcrStore(useShallow(({ setDcrFormSearchTerm }) => setDcrFormSearchTerm));

export const useSetDcrFormFilteredFields = () =>
	useDcrStore(
		useShallow(({ setDcrFormFilteredFields }) => setDcrFormFilteredFields)
	);
